import { AUTH_HEADERS } from '@libs/core/constants';
import {
    getAccessToken,
    getChatbotEnabled,
    getChatbotModel,
    getChatbotReasoning,
    getVisitorId,
    isAccessTokenAuth0,
} from '@libs/core/cookies';

export function chatHeaders() {
    const accessToken = getAccessToken();
    const chatbotEnabled = getChatbotEnabled();
    const isAuth0Enabled = isAccessTokenAuth0();
    const model = getChatbotModel();
    const reasoning = getChatbotReasoning();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const visitorId = getVisitorId();

    return {
        ...(accessToken && { [AUTH_HEADERS.AUTHORIZATION]: `Bearer ${accessToken}` }),
        ...(chatbotEnabled && { [AUTH_HEADERS.X_PETM_CHATBOT_ENABLED]: 'true' }),
        ...(isAuth0Enabled && { [AUTH_HEADERS.X_PETM_AUTH0_ENABLED]: 'true' }),
        ...(model && { [AUTH_HEADERS.X_PETM_CHATBOT_MODEL]: model }),
        ...(reasoning && { [AUTH_HEADERS.X_PETM_CHATBOT_REASONING]: reasoning }),
        ...(timeZone && { [AUTH_HEADERS.X_PETM_TIMEZONE]: timeZone }),
        ...(visitorId && { [AUTH_HEADERS.X_PETM_VISITOR_ID]: visitorId }),
    };
}
